import { createContext, useContext, useMemo } from 'react'
import { useGetTablesSimpleQuery } from '../../common/generated/apollo-operations'
import { SimpleTable } from '../tables/types'

interface TableMenuContextValue {
  tables: SimpleTable[]
  tablesLoading: boolean
}

export function TableMenuProvider({
  children,
}: {
  children: React.ReactNode
  workspaceId?: string
}) {
  const { data: tablesData, loading: tablesLoading } = useGetTablesSimpleQuery()
  const tables = useMemo(() => {
    return tablesData?.tables || []
  }, [tablesData?.tables])

  return (
    <TableMenuContext.Provider
      value={{
        tables,
        tablesLoading: !!tablesLoading,
      }}
    >
      {children}
    </TableMenuContext.Provider>
  )
}

export const useTableMenu = () => {
  const context = useContext(TableMenuContext)

  if (!context) {
    throw new Error('useTableMenu must be used within a TableMenuProvider')
  }

  return context
}

const TableMenuContext = createContext<TableMenuContextValue | null>(null)
